<template>
  <div class="app-container">
    <div style="margin-bottom: 15px; display: flex">
      <!-- :model="listQuery" ref="filterForm" :inline="true"> -->
      <!-- <el-form-item label="名稱" prop="NAME"> -->
      <div style="margin-right: 15px">
        <el-input v-model="listQuery.NAME" placeholder="搜尋簽署者姓名" clearable @keyup.enter.native="handleFilter" />
      </div>
      <div>
        <el-button plain round icon="el-icon-search" @click="handleFilter"> 搜尋 </el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('filterForm', listQuery, getList)"> 重置 </el-button>
        <el-button v-loading.fullscreen.lock="fullLoading" type="primary" icon="el-icon-plus" @click="handleCreate">
          新增
        </el-button>
        <el-button
          v-loading.fullscreen.lock="fullLoading"
          type="danger"
          icon="el-icon-delete"
          @click="handleBatchDelete">
          刪除
        </el-button>
      </div>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      fit
      highlight-current-row
      border
      stripe
      row-key="ID"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="50px" align="center" />
      <el-table-column label="序號" type="index" align="center" width="50px" />
      <el-table-column label="病歷號" prop="MEDICAL_RECORD_NO" align="center" width="200px" />
      <el-table-column label="姓名" prop="NAME" align="center" width="150px" />
      <el-table-column label="身份證字號" prop="ID_NUMBER" align="center" width="150px" />
      <el-table-column label="生日" prop="DATEOFBIRTH" align="center" width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.DATEOFBIRTH | parseTime('{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="性別" prop="SEX" align="center" width="100px">
        <template slot-scope="{ row }">
          <span>{{ row.SEX === 'M' ? '男性' : row.SEX === 'F' ? '女性' : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手機號碼" prop="PHONE" align="center" width="150px" />
      <el-table-column label="地址" prop="ADDRESS" align="center" />
      <el-table-column label="更新時間" prop="LAST_UPDATE_DATE" align="center" width="150px">
        <template slot-scope="{ row }">
          <!-- 2021-07-09 06:59:53 -->
          <span>{{ row.LAST_UPDATE_DATE | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160px" class-name="small-padding fixed-width">
        <template slot-scope="{ row }">
          <el-button type="primary" size="mini" @click="handleUpdate(row)"> 修改 </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(row)"> 删除 </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList" />

    <el-dialog
      width="800px"
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false">
      <el-form
        ref="formRef"
        class="dialog-from-margin"
        :rules="rules"
        status-icon
        :model="dataform"
        label-position="right"
        label-width="82px">
        <!-- v-if="dialogStatus==='create'" -->
        <el-form-item label="病歷號" prop="MEDICAL_RECORD_NO">
          <el-input v-model="dataform.MEDICAL_RECORD_NO" clearable show-word-limit placeholder="請輸入" />
        </el-form-item>
        <el-row :gutter="20">
          <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="24">
            <el-form-item label="姓名" prop="NAME">
              <el-input v-model="dataform.NAME" clearable show-word-limit placeholder="請輸入" />
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="24">
            <el-form-item label="身份證字號" prop="ID_NUMBER">
              <el-input v-model="dataform.ID_NUMBER" clearable show-word-limit placeholder="請輸入" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="24">
            <el-form-item label="生日" prop="DATEOFBIRTH">
              <el-date-picker v-model="dataform.DATEOFBIRTH" type="date" placeholder="選擇日期" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="24">
            <el-form-item label="性別" prop="SEX" right>
              <el-select v-model="dataform.SEX" clearable placeholder="請選擇" style="width: 100px">
                <el-option
                  v-for="item in [
                    { value: 'M', label: '男性' },
                    { value: 'F', label: '女性' }
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="手機號碼" prop="PHONE">
          <el-input v-model="dataform.PHONE" clearable show-word-limit placeholder="請輸入" />
        </el-form-item>
        <el-form-item label="地址" prop="ADDRESS">
          <el-input v-model="dataform.ADDRESS" clearable show-word-limit placeholder="請輸入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false"> 取消 </el-button>
        <el-button type="primary" @click="dialogStatus === 'create' ? createData() : updateData()"> 確定 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { patientInfo, createPatient, updatePatient, deletePatient, countPatient } from '@/api/patients'
import Pagination from '@/components/Pagination' // 分页

export default {
  name: 'Patients',
  components: {
    Pagination
  },
  data() {
    const medicalNoValidator = (rule, value, callback) => {
      let query
      if (this.dialogStatus === 'create') {
        query = { MEDICAL_RECORD_NO: value }
      } else {
        query = { MEDICAL_RECORD_NO: value, ID: this.dataform.ID }
      }
      countPatient(query).then((response) => {
        if (response.data.result > 0) {
          callback(new Error('已存在，請重新輸入'))
        } else {
          callback()
        }
      })
    }

    return {
      list: [],
      total: 0,
      listLoading: true,
      fullLoading: false,
      // 默认展开节点
      expands: [],
      listQuery: {
        page: 1,
        limit: 10,
        NAME: undefined
      },
      dataform: {
        ID: undefined,
        MEDICAL_RECORD_NO: '',
        NAME: '',
        ID_NUMBER: '',
        DATEOFBIRTH: '',
        SEX: '',
        PHONE: '',
        ADDRESS: ''
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '修改',
        create: '新增'
      },
      rules: {
        MEDICAL_RECORD_NO: [
          { required: true, message: '請輸入', trigger: 'blur' },
          { validator: medicalNoValidator, trigger: 'blur' }
        ],
        NAME: [{ required: true, message: '請輸入', trigger: 'blur' }]
      },
      multipleSelection: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      patientInfo(this.listQuery)
        .then((response) => {
          this.expands = []
          this.list = response.data.result.rows
          this.total = response.data.result.count
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    resetForm(formName, query, getListMethod) {
      // this.$refs[formName].resetFields()
      query.NAME = undefined
      getListMethod()
    },
    resetTemp() {
      this.dataform = {
        ID: undefined,
        MEDICAL_RECORD_NO: '',
        NAME: '',
        ID_NUMBER: '',
        DATEOFBIRTH: '',
        SEX: '',
        PHONE: '',
        ADDRESS: ''
      }
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        // 重新加载上级部门数据
        this.$refs.formRef.clearValidate()
      })
    },
    createData() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.dataform.DATEOFBIRTH = this.parseTime(this.dataform.DATEOFBIRTH, '{y}-{m}-{d}')
          const tempData = Object.assign({}, this.dataform)
          this.fullLoading = true
          createPatient(tempData)
            .then(() => {
              this.fullLoading = false
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
                duration: 2000
              })
              // this.notifyMessage()
              this.getList()
            })
            .catch(() => {
              this.fullLoading = false
              this.dialogFormVisible = false
            })
        }
      })
    },
    handleUpdate(row) {
      this.dataform = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate()
      })
    },
    updateData() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.dataform.DATEOFBIRTH = this.parseTime(this.dataform.DATEOFBIRTH, '{y}-{m}-{d}')
          const tempData = Object.assign({}, this.dataform)

          this.fullLoading = true
          updatePatient(tempData)
            .then(() => {
              this.fullLoading = false
              this.dialogFormVisible = false
              // this.notifyMessage()
              this.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success',
                duration: 2000
              })
              this.getList()
            })
            .catch(() => {
              this.fullLoading = false
              this.dialogFormVisible = false
            })
        }
      })
    },
    handleDelete(row) {
      this.$confirm('確認刪除該記錄？', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.fullLoading = true
          deletePatient(row.ID)
            .then(() => {
              this.fullLoading = false
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
                duration: 2000
              })
              this.handleFilter()
            })
            .catch(() => {
              this.fullLoading = false
            })
        })
        .catch(() => {
          // 不執行任何動作
        })
    },
    handleBatchDelete() {
      if (!this.multipleSelection.length) {
        this.$message({ type: 'info', message: '請勾選你要刪除的數據' })
        return
      }

      this.$confirm('確認刪除該記錄？', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.fullLoading = true
          const promises = []

          this.multipleSelection.forEach((id) => {
            promises.push(deletePatient(id))
          })

          Promise.all(promises)
            .then(() => {
              this.fullLoading = false
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
                duration: 2000
              })
              this.handleFilter()
            })
            .catch(() => {
              this.fullLoading = false
            })
        })
        .catch(() => {
          // 不執行任何動作
        })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.ID)
    }
  }
}
</script>
